var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 16.2499C3.78832 16.2499 3.64524 16.1907 3.53975 16.0852C3.43426 15.9797 3.375 15.8366 3.375 15.6874L3.375 3.31242C3.37499 3.21467 3.40046 3.1186 3.44889 3.03369C3.49732 2.94878 3.56705 2.87795 3.65119 2.8282C3.73533 2.77844 3.83098 2.75147 3.92872 2.74995C4.02646 2.74842 4.12292 2.77239 4.20857 2.8195L15.4586 9.007C15.5468 9.05554 15.6204 9.12688 15.6717 9.21358C15.723 9.30029 15.75 9.39917 15.75 9.49989C15.75 9.60062 15.723 9.6995 15.6717 9.7862C15.6204 9.8729 15.5468 9.94425 15.4586 9.99278L4.20857 16.1803C4.12552 16.226 4.03228 16.2499 3.9375 16.2499ZM4.5 4.26355L4.5 14.7361L14.0202 9.49992L4.5 4.26355Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.9a1b6176c97161ce98d408a96fc6fffc.svg";
export { ForwardRef as ReactComponent };